<script>
  import relatorioServico from '../relatorio.servico';
  import projetoServico from '~modulos/projeto/servico';

  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';
  import 'vue-strap/dist/vue-strap-lang';

  import { radio, datepicker } from 'vue-strap';
  import CabecalhoRelatorio from '~componentes/CabecalhoRelatorio.vue';
  import TelaCheia from '~componentes/TelaCheia.vue';
  
  export default {
    components: { datepicker, radio, CabecalhoRelatorio, TelaCheia },
    data() {
      return {
        filtros: {
          dataInicio: moment(new Date()).format('DD/MM/YYYY'),
          dataFim: moment(new Date()).format('DD/MM/YYYY'),
          idProjeto: '',
        },
        projetos: [],
        relatorio: [],
      }
    },
    methods: {
      listaDeProjetos() {
        return projetoServico
          .listaDeProjetosPermissao("RelVerificacaoLancamento")
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      gerar() {
        this.relatorio = {};

        this.$validator
          .validateAll()
          .then(valido => {
            if (!valido) throw new Error("validacao");
            
            $('#gerar').button('loading');

            return relatorioServico.verificacaoDePagamentosFornecedor(this.filtros)
          })
          .then(resultado => {
            this.relatorio = resultado.groupBy('nomeProjeto');
            
            $('#gerar').button('reset');
            
            if (resultado.length === 0) {
              this.$swal('', 'Nenhum resultado encontrado.', 'info');
            } else {
              this.$nextTick(() => {
                $('html, body').animate({
                  scrollTop: $('#relatorio').offset().top
                }, 800);
              });
            }
          })
          .catch(erro => {
            $('#gerar').button('reset');

            if (erro.status === 422) {
              this.$mensagemErro(erro, erro.body.message);
            } else {
              this.$mensagemErro(erro, 'Erro ao gerar relatório.');
            }
          });
      },
      limparTermoDeBusca() {
        this.filtros.termoDeBusca = '';
      },
      formatarData(data) {
        return data ? this.$options.filters.formatarData(data) : '---';
      },
      totalValorBruto(lancamentos) {
        return lancamentos.reduce((total, lancamento) => {
          return total + lancamento.valorBruto;
        }, 0);
      },
      totalValorLiquido(lancamentos) {
        return lancamentos.reduce((total, lancamento) => {
          return total + lancamento.valorLiquido;
        }, 0);
      },
      totalIrrf(lancamentos) {
        return lancamentos.reduce((total, lancamento) => {
          return total + lancamento.irrf;
        }, 0);
      },
      totalIss(lancamentos) {
        return lancamentos.reduce((total, lancamento) => {
          return total + lancamento.iss;
        }, 0);
      },
      totalInssRetencao(lancamentos) {
        return lancamentos.reduce((total, lancamento) => {
          return total + lancamento.inssRetencao;
        }, 0);
      },
      totalCofins(lancamentos) {
        return lancamentos.reduce((total, lancamento) => {
          return total + lancamento.cofins;
        }, 0);
      },
      totalPis(lancamentos) {
        return lancamentos.reduce((total, lancamento) => {
          return total + lancamento.pis;
        }, 0);
      },
      totalCsll(lancamentos) {
        return lancamentos.reduce((total, lancamento) => {
          return total + lancamento.csll;
        }, 0);
      }
    },
    computed: {
    },
    mounted() {
      this.$root.tituloDaPagina = `Relatório de Verificação de Pagamento do Fornecedor`;
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoLink = '';

      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';

      this.$events.on('botaoAcao', function() {
        window.print();
      });

      this.listaDeProjetos();

      const _this = this;

      //$('.datepicker input').attr('readonly', '');

      $('#projeto').select2({
        theme: "bootstrap",
        placeholder: "Selecione...",
        language: "pt-BR",
        allowClear: true
      })
      .change(function(e) {
        _this.$set(_this.filtros, 'idProjeto', this.value);
      });
    },
    watch: {
    },
    beforeDestroy() {
      this.$events.off('botaoAcao');
    }
  }
</script>

<template>
  <div :class="['wrapper wrapper-content animated', $root.animacaoPadrao]">
    <form class="hidden-print" @submit.prevent="gerar">

      <div class="ibox float-e-margins">
        <div class="ibox-content">

          <div class="row">
            <div class="col-sm-6">
              <div class="form-group required" :class="{'has-error': errors.has('dataInicio')}">
                <label class="control-label">Período</label>

                <datepicker id="dataInicio"
                            v-mascara="'data-mask'"
                            v-model="filtros.dataInicio"
                            format="dd/MM/yyyy"
                            placeholder="  /  /     "
                            lang="pt-BR">
                </datepicker>

                <p class="text-danger" v-show="errors.has('dataInicio')">{{ errors.first('dataInicio') }}</p>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group" :class="{'has-error': errors.has('dataFim')}">
                <label class="control-label">&nbsp; &nbsp;</label>

                <datepicker id="dataFim"
                            v-mascara="'data-mask'"
                            v-model="filtros.dataFim"
                            format="dd/MM/yyyy"
                            placeholder="  /  /     "
                            lang="pt-BR">
                </datepicker>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label class="control-label" for="projeto">Projeto</label>

                <select id="projeto"
                        class="form-control"
                        v-model="filtros.idProjeto">
                  <option value="">Selecione...</option>
                  <option :value="projeto.idProjeto" v-for="(projeto, index) in projetos">{{ projeto.nomeProjeto }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <button
                id="gerar"
                type="button"
                class="btn btn-primary"
                @click="gerar"
                data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando relatório...">
                <i class="fa fa-line-chart"></i>
              Gerar relatório
            </button>

            <tela-cheia
              texto="Visualizar em tela cheia"
              icone="arrows-alt"
              v-if="Object.keys(relatorio).length !== 0">
            </tela-cheia>
          </div>
        </div>
      </div>
    </form>

    <cabecalho-relatorio titulo="Relatório de Verificação de Pagamento" borda=""></cabecalho-relatorio>

    <div class="row" v-if="Object.keys(relatorio).length !== 0" id="relatorio">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">

            <div class="table-responsive">
              <template v-for="grupo in relatorio">
                <table class="table relatorio table-bordered">
                  <thead>
                    <tr>
                      <th colspan="17">{{ grupo[0].nomeProjeto }}</th>
                    </tr>
                    <tr>
                      <th>Data</th>
                      <th>Dados do pagamento</th>
                      <th>Banco</th>
                      <th>Agência</th>
                      <th>Nº conta</th>
                      <th class="text-center">C/D</th>
                      <th>Doc. Rec./Pag.</th>
                      <th class="text-right">Valor bruto</th>
                      <th class="text-right">IRRF</th>
                      <th class="text-right">ISS</th>
                      <th class="text-right">INSS Retenção</th>
                      <th class="text-right">COFINS</th>
                      <th class="text-right">PIS</th>
                      <th class="text-right">CSLL</th>
                      <th class="text-right">Valor líquido</th>
                      <th class="text-center">Código</th>
                      <th>Devolvido em</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="lancamento in grupo">
                      <td>{{ lancamento.data | formatarData }}</td>
                      <td>{{ lancamento.historico }}</td>
                      <td>{{ lancamento.numeroBanco }}</td>
                      <td>{{ lancamento.numeroAgencia }}</td>
                      <td>{{ lancamento.numeroContaTerceiro }}</td>
                      <td class="text-center">{{ lancamento.creditoDebito === 1 ? 'C' : 'D' }}</td>
                      <td>{{ lancamento.documentoReceberPagar }}</td>
                      <td class="text-right">{{ lancamento.valorBruto | formatarNumero }}</td>
                      <td class="text-right">{{ lancamento.irrf | formatarNumero }}</td>
                      <td class="text-right">{{ lancamento.iss | formatarNumero }}</td>
                      <td class="text-right">{{ lancamento.inssRetencao | formatarNumero }}</td>
                      <td class="text-right">{{ lancamento.cofins | formatarNumero }}</td>
                      <td class="text-right">{{ lancamento.pis | formatarNumero }}</td>
                      <td class="text-right">{{ lancamento.csll | formatarNumero }}</td>
                      <td class="text-right">{{ lancamento.valorLiquido | formatarNumero }}</td>
                      <td class="text-center">{{ lancamento.idLancamento }}</td>
                      <td>{{ formatarData(lancamento.dataDevolucao) }}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="7"><b>Total</b></td>
                      <td class="text-right"><b>{{ totalValorBruto(grupo) | formatarNumero }}</b></td>
                      <td class="text-right"><b>{{ totalIrrf(grupo) | formatarNumero }}</b></td>
                      <td class="text-right"><b>{{ totalIss(grupo) | formatarNumero }}</b></td>
                      <td class="text-right"><b>{{ totalInssRetencao(grupo) | formatarNumero }}</b></td>
                      <td class="text-right"><b>{{ totalCofins(grupo) | formatarNumero }}</b></td>
                      <td class="text-right"><b>{{ totalPis(grupo) | formatarNumero }}</b></td>
                      <td class="text-right"><b>{{ totalCsll(grupo) | formatarNumero }}</b></td>
                      <td class="text-right"><b>{{ totalValorLiquido(grupo) | formatarNumero }}</b></td>
                      <td colspan="2"></td>
                    </tr>
                  </tfoot>
                </table>
              </template>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/relatorio/componentes/VerificacaoDePagamentosFornecedor.vue